import React, { useEffect } from 'react';
import './index.scss';
import {
    SuccessFeedbackScreen,
    ButtonPrimary,
    ErrorFeedbackScreen,
    skinVars,
    useWindowSize,
} from '@telefonica/mistica';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { TrackingEvents } from '../../../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../../../utils/navigation/controlDevices';
import navigateParams from '../../../../../utils/navigation/navigateParams';

export const CancelAppointmentFeedback: React.FC = () => {
    const { t } = useTranslation();
    const { state } = useLocation();
    const navigate = useNavigate();
    const { trackingScreenView } = new TrackingEvents();
    const stateFeedback = state?.stateFeedback;
    const err = state?.err;
    const size = useWindowSize();

    const sendToNative = (url: string) => {
        const type = 'modeFlow-backgroundBlue';
        const queryParams = {};
        if (navigateParams(type, url, queryParams)) {
            navigate(url);
        }
    };

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
    }, []);

    return (
        <div
            className='feedbackCancelAppointment-page'
            style={{
                background:
                    stateFeedback === 'SUCCESS'
                        ? size.width < 1024 || size.height < 550
                            ? skinVars.colors.backgroundBrand
                            : ''
                        : skinVars.colors.background,
            }}
        >
            {stateFeedback === 'SUCCESS' ? (
                <SuccessFeedbackScreen
                    title={t('rehabilitationLinesInfoFeedbackTitle')}
                    description={t('successFeedbackCancelAppointment')}
                    primaryButton={
                        <ButtonPrimary
                            onPress={() => {
                                sendToNative('/profile/orders');
                            }}
                        >
                            {t('buttonUnderstoodFeedback')}
                        </ButtonPrimary>
                    }
                ></SuccessFeedbackScreen>
            ) : (
                <ErrorFeedbackScreen
                    title={err.title}
                    description={err.localizedDescription}
                    errorReference={'Código de error: ' + `${err.id}`}
                    primaryButton={
                        <ButtonPrimary
                            onPress={() => {
                                sendToNative('/profile/orders');
                            }}
                        >
                            {t('changesPasswordErrorFeedbackButton')}
                        </ButtonPrimary>
                    }
                ></ErrorFeedbackScreen>
            )}
        </div>
    );
};

export default CancelAppointmentFeedback;
